import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { find, cloneDeep, get, capitalize, map, isEqual, startCase } from 'lodash';
import store from '../../helpers/store'
import ReactSelect from '../../components/common/ReactSelect';
import SearchWidget from '../../components/pages/home/SearchWidget';
import FilterList from '../../components/widgets/entityFilter/FilterList';
import EntityFilter from '../../components/widgets/entityFilter/EntityFilter';
import CSVImportModal from '../../components/common/CSVImportModal';
import CSVSampleDownload from '../../components/common/CSVSampleDownload';
import Multiselect from '../../components/common/Multiselect/Multiselect';
import FieldMapper from '../../components/widgets/entityFilter/FieldMapper';
import Spinner from '../../components/common/Spinner';
import MatchMediaWrapper from '../../helpers/MatchMediaWrapper';
import FieldSelector from '../../components/common/Datagrid/FieldsSelector';
import { imprintsActions } from '../../data/actions/imprints';
import { artistsActions } from '../../data/actions/artists';
import { productsActions } from '../../data/actions/products';
import { projectsActions } from '../../data/actions/projects';
import { tracksActions } from '../../data/actions/tracks';
import { userEntityFiltersActions } from '../../data/actions/user_entity_filters';
import { imprintsSettings } from '../../components/pages/imprints/Settings';
import { artistsSettings } from '../../components/pages/artists/Settings';
import { projectsSettings } from '../../components/pages/projects/Settings';
import { productsSettings } from '../../components/pages/products/Settings';
import { tracksSettings } from '../../components/pages/tracks/Settings';
const allEntityTypes = ['imprints', 'artists', 'products', 'projects', 'tracks'];
import durations from '../../components/widgets/filter/enums/durations.json';
import vendors from '../../components/widgets/filter/enums/vendors.json';
import content_types from '../../components/widgets/filter/enums/content_types.json';
import demo from './demo';

const fieldsSettings = {
	imprints: imprintsSettings,
	artists: artistsSettings,
	projects: projectsSettings,
	products: productsSettings,
	tracks: tracksSettings
};

const deleteSvg = require('!svg-inline-loader!../../../public/img/icons/delete.svg');
const editSvg = require('!svg-inline-loader!../../../public/img/icons/edit.svg');

class CatalogReportDetails extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			baseEntity: null,
			duration: -1,
			sorted: [{id: 'curr_units', desc: true}],
			fields: [],
			vendorFields: [],
			globalFilter: {},
			entityFilter: []
		}
		this.setFilterValue = this.setFilterValue.bind(this);
		this.setDateRanges = this.setDateRanges.bind(this);
		this.setFields = this.setFields.bind(this);
	}
	
	componentDidMount(){
		const { match, dispatch } = this.props; 
		const { id } = match.params;
		dispatch(userEntityFiltersActions.getUserEntityFilters(true))
	}
	
	componentWillReceiveProps(nextProps){
		const { match, dispatch } = nextProps; 
		const { id } = match.params;
		const { match: currentMatch } = this.props;
		const currentId = currentMatch.params.id;
		if(currentId && id != currentId) {
		}
		
	}
	
	setFilterValue(v, k){
		this.setState({
			[k]: v
		})
	}
	
	setDateRanges(duration) {
	  const numberOfDays = find(durations, d=>d.value == duration).offset.days;
	  const fmt = "YYYY-MM-DD";
	  const date_end       = moment().subtract(2, "days");
	  const date_start     = date_end.clone().subtract(numberOfDays, "days");
	  const prev_date_end  = date_start.clone().subtract(1, "day");
	  const prev_date_start = prev_date_end.clone().subtract(numberOfDays, "days");
	
	  this.setState({
		 ...this.state, 
		duration, 
		globalFilter: {
			...this.state.globalFilter,
			dateEnd:        date_end.format(fmt),
			dateStart:      date_start.format(fmt),
			prevDateEnd:   prev_date_end.format(fmt),
			prevDateStart: prev_date_start.format(fmt),
		}
	  }, ()=>{
		  console.log(this.state);
	  });
	}
	
	setFields(fields){
		const flatColumns = fields.filter(f=>!f.includes('.'));
		const vendorColumns = fields.filter(f=>f.includes('.')).map(f=>{
			const [contentTypeName, vendorName] = f.split('.');
			const vendor = find(vendors, v=>v.label.toLowerCase() == vendorName.toLowerCase());
			const contentType = find(content_types, ct=>ct.label.toLowerCase() == contentTypeName.toLowerCase());
			const columnName = [contentTypeName, vendorName].map(n=>n.replace(/[ -]+/g, '_')).join('_');
			return {
				vendor: vendor.vend_id,
				content_type: contentType.value,
				column_name: columnName
			};
		});
		this.setState({
			...this.state,
			fields: flatColumns,
			vendorFields: vendorColumns
		})
	}
	
	buildParams(){
		
		let { entityFilter, sorted } = this.state;
		const filteredArray = Object.entries(
			entityFilter.reduce((acc, { entity_type, entity_id }) => {
				if (!acc.hasOwnProperty(entity_type))
					acc[entity_type] = [];
				acc[entity_type].push(entity_id);
				return acc;
			}, {})
		).map(([id, value]) => ({ id, value }));
		filteredArray.push({ id: 'result', value: 'sql' });
		
		return {
			page: 1,
			sorted: sorted,
			filtered: filteredArray
		}
	}
	
	setData(){
		this.setState({
			...demo
		})
	}
	
	makeRequest(){
		const { dispatch } = this.props;
		const { baseEntity, globalFilter, fields, vendorFields } = this.state;
		const params = this.buildParams();
		switch(baseEntity) {
			case 'tracks':
				return dispatch(tracksActions.getAllTracks(params, globalFilter, fields, vendorFields));
				break;
			case 'artists':
				return dispatch(artistsActions.getAllArtists(params, globalFilter, fields, vendorFields));
				break;
			case 'products':
				return dispatch(productsActions.getAllProducts(params, globalFilter, fields, vendorFields));
				break;
			case 'projects':
				return dispatch(projectsActions.getAllProjects(params, globalFilter, fields, vendorFields));
				break;
			case 'imprints':
				return dispatch(imprintsActions.getAllImprints(params, globalFilter, fields, vendorFields));
				break;
		}
		
	}
	
	formatTitle(str) {
		return startCase(str);
	}
	
	renderBaseEntity(){
		const elements = allEntityTypes.map(e=>({
			label: capitalize(e),
			value: e
		}));
		const { baseEntity: selected } = this.state;
		return <div>
			<h6>Base Entity Type</h6>
			<Multiselect elements={elements} selected={selected} handleChange={v=>this.setFilterValue(v, 'baseEntity')} />
		</div>
	}
	
	renderDurations(){
		const { duration: selected } = this.state;
		const elements = durations.filter(d=>d.value <= 3);
		console.log(elements);
		return <div>
			<h6>Date Range</h6>
			<Multiselect elements={elements} selected={selected} handleChange={v=>this.setDateRanges(v)} />
		</div>
	}
	
	renderFieldSelector(baseEntity){
		const { fields } = this.state;
		if(!baseEntity)
			return null;
		const settings = fieldsSettings[baseEntity].settingsForTable(fields);	
		return <div>
			<h6>Fields</h6>
			<FieldSelector key={baseEntity} settings={settings} current={{columns: fields}} onUpdate={v=>this.setFields(v.columns)} extraClassName="catalog-field-selector" />
		</div>
	}
	
	renderGlobalFilters(){
		const { globalFilter } = this.state;
		const savedFilters = get(this.props, 'filter.data', []);
		const mapSavedFilters = savedFilters.map(filter => ({label: filter.filter_name, value: filter.id, user_id: filter.user_id, is_shared: filter.is_shared, body: filter.filter_body}));
		const selectedOption = find(mapSavedFilters, filter=>isEqual(filter.body, globalFilter))
		return <div>
			<h6>Global Filter</h6>
			<div>
				<ReactSelect options={mapSavedFilters} placeholder="Choose Global Filter" onChange={v=>this.setFilterValue(v.body, 'globalFilter')} value={selectedOption} className="select-wrapper" />
			</div>
			<div>
			<ul>
				{Object.keys(globalFilter).map(f=><li key={f}>{this.formatTitle(f)}: {Array.isArray(globalFilter[f])?globalFilter[f].join(', '):globalFilter[f]}</li>)}
			</ul>
			</div>
		</div>
	}
	
	renderEntityFilters(){
		const { entityFilter } = this.state;
		const savedFilters = get(this.props, 'userEntityFilters.filters', []);
		const mapSavedFilters = savedFilters.map(filter => ({label: filter.caption, value: filter.id, user_id: filter.user_id, is_shared: filter.is_shared, body: filter.entities}));
		const selectedOption = find(mapSavedFilters, filter=>isEqual(filter.body, entityFilter))

		return <div>
			<h6>Entity Filter</h6>
			<div>
				<ReactSelect options={mapSavedFilters} placeholder="Choose Entity Filter" onChange={v=>this.setFilterValue(v.body, 'entityFilter')} value={selectedOption} className="select-wrapper" />
			</div>
			<div>
			<ul>
				{entityFilter.map(e=><li key={e.entity_id}>{e.entity_title}</li>)}
			</ul>
			</div>
		</div>
	}

	
	render() {
		const { baseEntity } = this.state;
		return (
			<div className="user-entity-filter-holder create-filter">
			{this.renderBaseEntity()} 
			{this.renderFieldSelector(baseEntity)}
			{this.renderGlobalFilters()} 
			{this.renderDurations()} 
			{this.renderEntityFilters()}
			<button onClick={()=>this.setData()}>set data (demo)</button>
			<button onClick={()=>this.makeRequest()}>go</button>
			</div>   
		)
	}
}

function mapStateToProps(state) {
	return {
		filter: state.filter,
		userEntityFilters: state.userEntityFilters
	} 
}
export default connect(mapStateToProps)(CatalogReportDetails);